import { isMobile } from './is-mobile'

/*
 * collapse animation for navbar dropdown
 * ----------------------------------------------- */
jQuery(function ($) {
  if (isMobile()) {
    $('[data-toggle-touch="collapse"]').on('click', function (e) {
      $(this)
        .closest('.collapse-parent')
        .toggleClass('open')
        .children('.collapse')
        .collapse('toggle')

      e.preventDefault()
    })
  } else {
    $('[data-toggle-hover="collapse"]')
      .closest('.collapse-parent')
      .hover(
        function () {
          var $this = $(this)
          $this.addClass('open').children('.collapse').stop().slideDown(120)

          var timer = setInterval(function () {
            if (
              $this.hasClass('open') &&
              $this.children('.collapse-child').css('display') === 'none'
            ) {
              $this.children('.collapse').stop().slideDown(120)
            }

            if ($this.children('.collapse').is(':visible')) {
              clearTimeout(timer)
            }
          }, 100)
        },
        function () {
          var $this = $(this)
          $this.removeClass('open')

          var timer = setInterval(function () {
            if (
              !$this.hasClass('open') &&
              $this.children('.collapse-child').css('display') === 'block'
            ) {
              $this.children('.collapse').stop().slideUp(40)
            }

            if ($this.children('.collapse').is(':hidden')) {
              clearTimeout(timer)
            }
          }, 100)
        }
      )
  }
})
